import type { IServiceMap } from '../services';

export const CampaignManagement: IServiceMap = {
  setup: {
    accountAndWorkspaceSetup: true,
    pixelInstallationUpTo3Domains: true,
    groupCreation: 1,
    customDataRequests: '2 per flight',
    conversionPixels: 1,
    contactRecordImports: 1,
    dataImportAndListCleaning: false,
  },
  calls: {
    dedicatedFlightManagementTeam: true,
    quarterlyReview: true,
    kickOffAndFinalReport: true,
    liveTrainingSessions: 0,
    liveStrategist: true,
    dedicatedSupportRep: false,
  },
  implementations: {
    implementationsPageVisible: true,
  },
  creatives: {
    credits: 15,
    creativeABTesting: true,
    starterSet: true,
  },
  execution: {
    flightSetupAndManagement: true,
    biweeklyHealthChecks: true,
    liveCampaignReportLinks: true,
    reusableFlightTemplate: true,
    formattedFinalReport: true,
  },
};
